/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  name: string;
  description: string;

  /** @format date-time */
  timestamp: string;
}

export interface CheckDataSetRequest {
  /**
   * Любой набор данных, преобразованных в формат Base64. (при проверке подписи происходит дешифровка из Base64 в оригинальный набор данных) Пример значения: MIIMNgYJKMCAQExDj==
   *
   */
  signedData: string;

  /** Строка подписи, сформированная СКЗИ на клиенте. Передаётся в виде Base64-строки. Пример значения: MIIMNgYJKMCAQExDj== */
  signature: string;

  /**
   * Идентификатор уполномоченного лица в MS Клиентский профиль
   * @format uuid
   */
  userId: string;
  certificate: Certificate;
}

export interface CheckSignatureRequest {
  document: Document;

  /** Версия ККБ */
  ccbVersion: string;
  certificate: Certificate;

  /**
   * Подпись, которую необходимо проверить. Передаётся в виде Base64-строки. Пример значения: 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
   *
   */
  signature: string;
}

export interface Document {
  /** Описание документа */
  type: DocumentType;
  fields: DocumentFields;
}

/**
 * Информация, специфичная для подтверждения через СМС
 */
export interface SmsConfirmInfo {
  /** Идентификатор пользователя в PayControl, от имени которого выполнялась генерация кода подтверждения. */
  paycontrolId: string;

  /** Идентификатор транзакции в PayControl. */
  transactionId: string;
}

/**
 * Информация, специфичная для подтверждения через УНЭП
 */
export interface TokenConfirmInfo {
  /** Идентификатор сертификата. */
  certNumber: string;

  /** Имя эмитента сертификата (центра сертификации). */
  certIssuer: string;

  /**
   * Дата и время создания подписи.
   * @format date-time
   */
  signatureDate: string;
}

/**
 * Информация, специфичная для подтверждения через PayControl
 */
export interface PaycontrolConfirmInfo {
  /** Идентификатор пользователя в PayControl, от имени которого выполнялось подтверждение транзакции. */
  paycontrolId: string;

  /** Идентификатор транзакции в PayControl. */
  transactionId: string;
}

export interface ConfirmRecord {
  /** Способ подтверждения */
  type: ConfirmType;

  /** Информация, специфичная для подтверждения через СМС */
  sms?: SmsConfirmInfo;

  /** Информация, специфичная для подтверждения через УНЭП */
  token?: TokenConfirmInfo;

  /** Информация, специфичная для подтверждения через PayControl */
  paycontrol?: PaycontrolConfirmInfo;

  /**
   * Дата и время проверки подписи (УНЭП), если confirmType равен token, или дата и время генерации кода PayControl, если confirmType равен sms.
   *
   * @format date-time
   */
  date: string;

  /**
   * Идентификатор пользователя. Соответствует delegates.id, передаваемому через топик plt_client-registry_client_pub.
   * @format uuid
   */
  userId: string;

  /** Роль подписи. Например, first или second. */
  role: string;
}

/**
 * Способ подтверждения
 */
export enum ConfirmType {
  Sms = "sms",
  Token = "token",
  Paycontrol = "paycontrol",
}

/**
 * Способ подтверждения
 */
export interface ConfirmMethod {
  /** Способ подтверждения */
  type: ConfirmType;

  /** Название способа подтверждения, которое можно отобразить пользователю (например, это может быть название мобильного устройства, привязанного к пользователю) */
  name: string;

  /** Идентификатор устройства подтверждения (например, может быть PayControlId мобильного устройства в случае с подтверждением через PayControl) */
  deviceId?: string;
}

/**
 * Описание документа
 */
export interface DocumentType {
  /** Название типа документа (латиницей). */
  name: string;

  /** Описание типа документа, которое может быть отображено пользователю. */
  desc: string;
}

export type DocumentFields = Record<
  string,
  object | number | string | any[] | boolean | (object & any[])
>;

export interface GenerateConfirmCodeRequest {
  document: Document;

  /** Номер версии ККБ */
  ccbVersion: string;

  /**
   * Шаблон текста сообщения, отправляемого клиенту. Шаблон должен содержать %s, где %s при формировании сообщения клиенту будет заменено на сгенерированный код.
   *
   */
  messageTemplate: string;
}

export interface GenerateConfirmCodeResponse {
  /** Период времени (в секундах), который валиден сгенерированный код подтверждения */
  validPeriodInSec: number;

  /** Количество допустимых попыток проверки кода подтверждения */
  attemptsCount: number;
}

export interface GeneratePayControlConfirmCodeRequest {
  /** Данные транзакции, представленные в формате base64 */
  data: string;

  /**
   * Шаблон текста сообщения, отправляемого клиенту. Шаблон должен содержать %s, где %s при формировании сообщения клиенту будет заменено на сгенерированный код.
   *
   */
  messageTemplate: string;
}

export interface GeneratePayControlConfirmCodeResponse {
  /** Идентификатор транзакции PayControl */
  transactionId: string;

  /** Период времени (в секундах), который валиден сгенерированный код подтверждения */
  validPeriodInSec: number;

  /** Количество допустимых попыток проверки кода подтверждения */
  attemptsCount: number;
}

export interface CheckConfirmationCodeRequest {
  /** Идентификатор документа */
  documentId: string;

  /** Название типа документа */
  documentType: string;

  /** Код подтверждения */
  code: string;
}

export interface CheckPayControlConfirmationCodeRequest {
  /** Идентификатор транзакции PayControl */
  transactionId: string;

  /** Код подтверждения */
  code: string;
}

export interface CheckPayControlConfirmationCodeResponse {
  /** Результат проверки кода подтверждения. true - код указан корректный, false - код невалидный. */
  valid: boolean;

  /** Подпись в виде строки в формате base64. Возвращается в случае успешного подтверждения. */
  signature?: string;
}

export interface GetPayControlTransactionStatusResponse {
  /** Идентификатор пользователя создавшего и подтвердившего транзакцию */
  userId: string;

  /** Результат подтверждения транзакции PayControl */
  status: PayControlTransactionStatus;

  /** Подпись в виде строки в формате base64. Возвращается в случае успешного подтверждения. */
  signature?: string;
}

/**
 * Результат подтверждения транзакции PayControl
 */
export enum PayControlTransactionStatus {
  CONFIRMED = "CONFIRMED",
  NOT_CONFIRMED = "NOT_CONFIRMED",
}

export interface CheckDataSetResponse {
  /** Результат валидности проверенной подписи. true - подпись валидна, false - подпись невалидна. */
  valid: boolean;
  certificate: Certificate;

  /**
   * Дата проверки подписи
   * @format date-time
   */
  date?: string;

  /** Заполняется, если результат проверки принимает значение False. */
  desc?: string;
}

export interface CheckSignatureResponse {
  /** Результат валидности проверенной подписи. true - подпись валидна, false - подпись невалидна. */
  valid: boolean;
  certificate: Certificate;

  /**
   * Дата проверки подписи
   * @format date-time
   */
  date?: string;

  /** Комментарий */
  desc?: string;
}

export interface Certificate {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации) */
  issuer: string;
}

export interface CheckConfirmationCodeResponse {
  /** Результат проверки кода подтверждения. true - код указан корректный, false - код невалидный. */
  valid: boolean;
}

export interface CcbRegisterRequest {
  /** Тип операции/документа/заявки, к которому относится ККБ. */
  operationType: string;

  /** Версия ККБ */
  version: string;

  /** Значение ККБ есть json строка. Родительский элемент - ccb, элементом которого является массив элементов с тегами name - {"ccb":[{"name":"name1"},{"name":"name2"}]} */
  value: string;
}

export interface GetCCBResponse {
  /** Тип операции/документа/заявки, к которому относится ККБ. */
  operationType: string;

  /** Версия ККБ */
  version: string;

  /** Значение ККБ есть json строка. Родительский элемент - ccb, элементом которого является массив элементов с тегами name - {"ccb":[{"name":"name1"},{"name":"name2"}]} */
  value: string;
}

/**
 * ККБ документа в виде строки. Пример: {"document":{"type":{"name":"DepositOrder","desc":"Депозитная заявка"},"fields":{"sum":{"value":"5.00","desc":"Сумма"},"account":{"value":"40702810000000000001","desc":"Счет зачисления"},"inn":"77007700","employers":"","bic":"","desc":""}}}
 */
export type BuildDocumentCCBResponse = string;

/**
 * Схема подписи клиента
 */
export interface GetClientSignatureSchemeResponse {
  /** Список ролей подписи */
  signScheme: SignSchemeItem[];
}

export type MsParametersReq = string[];

export type MsParameters = MsParameter[];

export interface MsParameter {
  /** Название параметра */
  name: string;

  /** Значение параметра */
  value?: string;
}

export interface SignSchemeItem {
  /** Название роли подписи */
  role: string;

  /** Требующееся количество подписей */
  count: number;
}

export interface GetClientConfirmTypeResponse {
  /** Способ подтверждения */
  confirmType: ConfirmType;
}

export type GetClientConfirmTypeV2Response = ConfirmMethod[];

/**
 * Способ подтверждения
 */
export interface GetDocumentState {
  /** Статус документа */
  state: string;

  /** Описание */
  desc: string;

  /** Записи подтверждений */
  confirm: ConfirmRecord[];
}

export interface BuildDocumentCCBRequest {
  document: Document;
  ccbVersion: string;
}

export interface CreatePayControlTransactionRequest {
  document: Document;

  /** Номер версии ККБ */
  ccbVersion: string;

  /** Идентификатор устройства, зарегистрированного в PayControl, на котором будет выполняться подтверждение операции */
  payControlId: string;

  /**
   * Флаг, указывающий отправлять пуш уведомление на устройство клиента или нет. При выполнении операции подтверждения в интернет-банке значение должно передаваться равным true. При подтверждении операции в мобильном банке значение должно быть равным false, так как нет смысла отправлять push на устройство пользователя, потому что мобильное приложение узнает идентификатор созданной транзакции, получив ответ на запрос (см. поле transactionId в ответе).
   *
   */
  sendPush: boolean;
}

export interface CreatePayControlTransactionResponse {
  /** Идентификатор транзакции, созданной в PayControl. */
  transactionId: string;
}

export interface PayControlTransactionCallbackRequest {
  /** Callback-объект от PayControl. */
  pc_callback: PayControlCallback;
}

/**
 * Callback-объект от PayControl.
 */
export interface PayControlCallback {
  /** Тип callback-объекта. При передаче результата обработки (подтверждения) транзакции будет передаваться значение transaction_callback. */
  type?: string;

  /** Объект с описанием результата обработки (подтверждения) транзакции. */
  result?: { error_code?: number; error_message?: string };

  /** Версия callback-объекта. */
  version?: number;

  /** Подробности обработки (подтверждения) транзакции. */
  transaction_callback?: {
    transaction_id?: string;
    check_time?: number;
    confirmation?: { confirm_code?: string; signature?: string };
    declanation?: { decline_reason?: string; decline_code?: string };
    cancelation?: { reason?: string };
  };
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис "Подтверждения"
 * @version 0.0.1
 *
 * API микросервиса "Подтверждения"
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags BankSign
     * @name SignBank
     * @summary Подпись файла банковским сертификатом
     * @request POST:/api/confirmation/v1/internal/bank-sign
     */
    signBank: (data?: BuildDocumentCCBResponse, params: RequestParams = {}) =>
      this.request<BuildDocumentCCBResponse, void>({
        path: `/api/confirmation/v1/internal/bank-sign`,
        method: "POST",
        body: data,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name GetSettings
     * @summary Получение значений настроек микросервиса
     * @request POST:/api/confirmation/v1/external/settings
     * @secure
     */
    getSettings: (data: MsParametersReq, params: RequestParams = {}) =>
      this.request<MsParameters, void>({
        path: `/api/confirmation/v1/external/settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name Revoke
     * @summary Снятие установленной подписи текущего пользователя с документа
     * @request POST:/api/confirmation/v1/external/documents/{documentType}/{documentId}/signatures/revoke
     * @secure
     */
    revoke: (
      documentType: string,
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/documents/${documentType}/${documentId}/signatures/revoke`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name RevokeAll
     * @summary Снятие всех подписей с документа
     * @request POST:/api/confirmation/v1/external/documents/{documentType}/{documentId}/signatures/revoke-all
     * @secure
     */
    revokeAll: (
      documentType: string,
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/documents/${documentType}/${documentId}/signatures/revoke-all`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name CheckDataSet
     * @summary Проверка подписи под произвольным набором данных
     * @request POST:/api/confirmation/v1/internal/signatures/check-data-set
     */
    checkDataSet: (data: CheckDataSetRequest, params: RequestParams = {}) =>
      this.request<CheckDataSetResponse, void | ErrorMessage>({
        path: `/api/confirmation/v1/internal/signatures/check-data-set`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name CheckSignature
     * @summary Проверка подписи
     * @request POST:/api/confirmation/v1/external/signatures/check
     * @secure
     */
    checkSignature: (data: CheckSignatureRequest, params: RequestParams = {}) =>
      this.request<CheckSignatureResponse, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/signatures/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name GenerateConfirmCode
     * @summary Генерация кода подтверждения для документа
     * @request POST:/api/confirmation/v1/external/confirmation-code
     * @secure
     */
    generateConfirmCode: (
      data: GenerateConfirmCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<GenerateConfirmCodeResponse, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/confirmation-code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name CheckConfirmationCode
     * @summary Проверка кода подтверждения
     * @request POST:/api/confirmation/v1/external/confirmation-code/check
     * @secure
     */
    checkConfirmationCode: (
      data: CheckConfirmationCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<CheckConfirmationCodeResponse, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/confirmation-code/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name CreatePayControlTransaction
     * @summary Создание транзакции в PayControl
     * @request POST:/api/confirmation/v1/external/paycontrol/transaction
     * @secure
     */
    createPayControlTransaction: (
      data: CreatePayControlTransactionRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreatePayControlTransactionResponse, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/paycontrol/transaction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name PayControlTransactionCallback
     * @summary Получение результата подтверждения транзакции от PayControl
     * @request POST:/api/confirmation/v1/internal/paycontrol/transaction/result
     */
    payControlTransactionCallback: (
      data: PayControlTransactionCallbackRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/confirmation/v1/internal/paycontrol/transaction/result`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CCB
     * @name GetCcb
     * @summary Получение контрольного криптоблока
     * @request GET:/api/confirmation/v1/internal/ccb/{operationType}/{version}
     */
    getCcb: (
      operationType: string,
      version: string,
      params: RequestParams = {}
    ) =>
      this.request<GetCCBResponse, void>({
        path: `/api/confirmation/v1/internal/ccb/${operationType}/${version}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CCB
     * @name RegisterCcb
     * @summary Регистрация контрольного криптоблока
     * @request POST:/api/confirmation/v1/internal/ccb
     */
    registerCcb: (data: CcbRegisterRequest, params: RequestParams = {}) =>
      this.request<GetCCBResponse, ErrorMessage>({
        path: `/api/confirmation/v1/internal/ccb`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CCB
     * @name BuildDocumentCcb
     * @summary Получение контрольного криптоблока конкретного документа
     * @request POST:/api/confirmation/v1/internal/ccb/build
     */
    buildDocumentCcb: (
      data: BuildDocumentCCBRequest,
      params: RequestParams = {}
    ) =>
      this.request<BuildDocumentCCBResponse, ErrorMessage>({
        path: `/api/confirmation/v1/internal/ccb/build`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name GetClientSignatureScheme
     * @summary Получение схемы подписи для клиента
     * @request GET:/api/confirmation/v1/internal/signature-schemes/{clientId}
     */
    getClientSignatureScheme: (clientId: string, params: RequestParams = {}) =>
      this.request<GetClientSignatureSchemeResponse, ErrorMessage>({
        path: `/api/confirmation/v1/internal/signature-schemes/${clientId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения для клиента
     * @request GET:/api/confirmation/v1/internal/confirm-type/{clientId}
     */
    getClientConfirmType: (clientId: string, params: RequestParams = {}) =>
      this.request<GetClientConfirmTypeResponse, ErrorMessage>({
        path: `/api/confirmation/v1/internal/confirm-type/${clientId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name GetClientConfirmTypeV2
     * @summary Получение типа подтверждения для пользователя клиента
     * @request GET:/api/confirmation/v2/internal/confirm-type/{clientId}/{userId}
     */
    getClientConfirmTypeV2: (
      clientId: string,
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<GetClientConfirmTypeV2Response, ErrorMessage>({
        path: `/api/confirmation/v2/internal/confirm-type/${clientId}/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sign
     * @name GetDocumentState
     * @summary Получение статуса документа по сбору подписей
     * @request GET:/api/confirmation/v1/internal/document-state/{documentType}/{documentId}
     */
    getDocumentState: (
      documentType: string,
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<GetDocumentState, void>({
        path: `/api/confirmation/v1/internal/document-state/${documentType}/${documentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PayControl
     * @name GenerateConfirmCode2
     * @summary Генерация кода подтверждения для произвольной транзакции и отправка его в СМС
     * @request POST:/api/confirmation/v1/external/paycontrol/confirmation-code
     * @originalName generateConfirmCode
     * @duplicate
     * @secure
     */
    generateConfirmCode2: (
      data: GeneratePayControlConfirmCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<GeneratePayControlConfirmCodeResponse, void | ErrorMessage>({
        path: `/api/confirmation/v1/external/paycontrol/confirmation-code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PayControl
     * @name CheckConfirmationCode2
     * @summary Проверка кода подтверждения
     * @request POST:/api/confirmation/v1/external/paycontrol/confirmation-code/check
     * @originalName checkConfirmationCode
     * @duplicate
     * @secure
     */
    checkConfirmationCode2: (
      data: CheckPayControlConfirmationCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        CheckPayControlConfirmationCodeResponse,
        void | ErrorMessage
      >({
        path: `/api/confirmation/v1/external/paycontrol/confirmation-code/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PayControl
     * @name GetTransactionStatus
     * @summary Получение статуса подтверждения транзакции PayControl по идентификатору транзакции
     * @request GET:/api/confirmation/v1/internal/paycontrol/confirmation/{transactionId}/status
     */
    getTransactionStatus: (transactionId: string, params: RequestParams = {}) =>
      this.request<GetPayControlTransactionStatusResponse, void>({
        path: `/api/confirmation/v1/internal/paycontrol/confirmation/${transactionId}/status`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
